import clsx from "clsx";
import { FunctionComponent } from "react";

import * as styles from "./ContentBlockAdvertiserFlag.css";

interface Props {
  className?: string;
  advertiserName?: string;
  advertiserPreamble?: string;
}
// this component would get targeted on the frontend by the revenue team,
// and the logo would get replaced accordingly
// on the verge, the url links to theverge.com, so we can pass the brand url
// we should confirm all of this with the revenue team when this component is used
const FALLBACK_PREAMBLE = "Advertiser Content From";

const ContentBlockAdvertiserFlag: FunctionComponent<Props> = ({
  className,
  advertiserName,
  advertiserPreamble = FALLBACK_PREAMBLE,
}) => {
  return (
    <span className={clsx(styles.container, className)}>
      <span data-native-ad-id="preamble">
        {advertiserPreamble || FALLBACK_PREAMBLE}
      </span>
      <span className={styles.advertiserName}>{advertiserName}</span>
    </span>
  );
};

export default ContentBlockAdvertiserFlag;
